import { Company } from '../company/company.model';
import { Training } from '../training/training.model';
import { Trainer } from '../trainer/trainer.model';
import { TrainingSessionExtended } from '../session/extended.model';

export class Session {
    constructor(
        public id?: number,
        public title?: string,
        public startDate?: any,
        public theme?: string,
        public days?: number,
        public trainer?: string,
        public trainerId?: number,
        public type?: string,
        public price?: number,
        public priceCurrency?: string,
        public reference?: string,
        public language = 'fr',
        public timezone = 'Europe/Paris',
        public location?: any,
        public locationType = 'NONE',
        public local?: string,
        public room?: string,
        public roomSize?: number,
        public registrations?: number,
        public training?: any,
        public billing?: any,
        public deleted?: boolean,
        public subject?: any,
        public linkedTraining?: Training,
        public company?: Company,
        public trainingSessionExtended?: TrainingSessionExtended,
        public additionalTrainers?: Trainer[],
        public zevalAccessId?: string,
        public numberOfConfirmedStudents = 0,
        public numberOfUnconfirmedStudents = 0,
        public hours?: Hours[],
        public synchronizeSignature?: boolean,
        public timesheetSaved = false,
        public fees?: any
    ) {}
}

export type Hours = {
    date: string;
    startTime: string;
    endTime: string;
    id?: number;
    trainingSessionId?: number;
};



// WEBPACK FOOTER //
// ./src/app/_services/session/session.model.ts